import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router);

/* 初始路由 */
export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,

  scrollBehavior: (to, from) => {
    console.log('11', to)
    if (to.matched[0].path !== '/personalCenter/index' && to.matched[0].path !== "/activity/list" && to.matched[0].path !== "/projects/list") {
      return {
        x: 0,
        y: 0
      }
    }
  },
  routes: [{
      path: '/',
      name: 'index',
      component: () => import('@/views/index'),
      meta: {
        title: '新力公益基金会'
      }
    },
    {
      path: '/aboutUs',
      name: 'aboutus',
      component: () => import('@/views/aboutUs'),
      meta: {
        title: '关于基金会'
      }
    },
    {
      path: '/projects/list/',
      name: 'foundationProjects',
      component: () => import('@/views/projects/list'),
      meta: {
        title: '基金会项目'
      }
    },
    {
      path: '/projects/detail/:id',
      name: 'projectsDetails',
      component: () => import('@/views/projects/detail'),
      meta: {
        title: '基金会项目详情'
      }
    },
    {
      path: '/activity/list',
      name: 'activityList',
      component: () => import( /* webpackChunkName: "activityList" */ '@/views/activity/list'),
      meta: {
        title: '志愿者活动'
      }
    },
    {
      path: '/activity/detail/:id',
      name: 'activityDetail',
      component: () => import( /* webpackChunkName: "activityDetail" */ '@/views/activity/detail'),
      meta: {
        title: '活动详情'
      }
    },
    {
      path: '/activity/formElements',
      name: 'formElements',
      component: () => import( /* webpackChunkName: "formElements" */ '@/views/activity/formElements'),
      meta: {
        title: '活动报名表单'
      }
    },
    {
      path: '/partner/list',
      name: 'partnerList',
      component: () => import('@/views/partner/list'),
      meta: {
        title: '合作伙伴'
      }
    },
    {
      path: '/partner/form',
      name: 'partnerForm',
      component: () => import('@/views/partner/form'),
      meta: {
        title: '合作方申请'
      }
    },
    {
      path: '/partner/detail/:type',
      name: 'partnerDetail',
      component: () => import('@/views/partner/detail'),
      meta: {
        title: '合作方详情'
      }
    },
    {
      path: '/volunteer/userProtocol',
      name: 'userProtocol',
      component: () => import( /* webpackChunkName: "userProtocol" */ '@/views/volunteer/userProtocol'),
      meta: {
        title: '用户协议'
      }
    },
    {
      path: '/volunteer/form',
      name: 'volunteerForm',
      component: () => import( /* webpackChunkName: "volunteerForm" */ '@/views/volunteer/form'),
      meta: {
        title: '注册页面'
      }
    },
    {
      path: '/account/login',
      name: 'login',
      component: () => import( /* webpackChunkName: "login" */ '@/views/account/login'),
      meta: {
        title: '登录'
      }
    },
    {
      path: '/account/wechatCallback',
      name: 'wechatCallback',
      component: () => import( /* webpackChunkName: "wechatCallback" */ '@/views/account/wechatCallback'),
      meta: {
        title: '微信登录'
      }
    },
    {
      path: '/account/wechatBindAccount',
      name: 'wechatBindAccount',
      component: () => import( /* webpackChunkName: "wechatCallback" */ '@/views/account/wechatBindAccount'),
      meta: {
        title: '绑定账号'
      }
    },
    {
      path: '/account/forgotPwd',
      name: 'forgotPwd',
      component: () => import( /* webpackChunkName: "forgotPwd" */ '@/views/account/forgotPwd'),
      meta: {
        title: '忘记密码'
      }
    },
    {
      path: '/statusPage',
      name: 'statusPage',
      component: () => import( /* webpackChunkName: "statusPage" */ '@/views/statusPage'),
      meta: {
        title: '状态页面'
      }
    },
    {
      path: '/searchResult',
      name: 'searchResult',
      component: () => import( /* webpackChunkName: "searchResult" */ '@/views/searchResult'),
      meta: {
        title: '搜索结果页面'
      }
    },
    {
      path: '/personalCenter/index',
      name: 'personalCenter',
      component: () => import('@/views/personalCenter/index'),
      meta: {
        title: '个人中心'
      },
      redirect: '/personalCenter/activity',
      children: [{
          path: '/personalCenter/activity',
          name: 'personalCenterActivity',
          component: () => import('@/views/personalCenter/activity'),
          meta: {
            title: '我报名的活动',
          }
        },
        {
          path: '/personalCenter/activityPoll/:id',
          name: 'activityPoll',
          component: () => import('@/views/personalCenter/activityPoll'),
          meta: {
            title: '活动问卷',
          }
        },
        {
          path: '/personalCenter/integralRecord',
          name: 'integralRecord',
          component: () => import('@/views/personalCenter/integralRecord'),
          meta: {
            title: '我的积分记录',
          }
        },
        {
          path: '/personalCenter/downloadProof',
          name: 'downloadProof',
          component: () => import('@/views/personalCenter/downloadProof'),
          meta: {
            title: '下载证明',
          }
        },
        {
          path: '/personalCenter/myCollection',
          name: 'myCollection',
          component: () => import('@/views/personalCenter/myCollection'),
          meta: {
            title: '我的收藏',
          }
        },
        {
          path: '/personalCenter/myGroup',
          name: 'myGroup',
          component: () => import('@/views/personalCenter/myGroup'),
          meta: {
            title: '我的团体',
          }
        },
        {
          path: '/personalCenter/realName',
          name: 'realName',
          component: () => import('@/views/personalCenter/realName'),
          meta: {
            title: '实名认证',
          },
        },
        {
          path: '/personalCenter/changePwd',
          name: 'changePwd',
          component: () => import( /* webpackChunkName: "changePwd" */ '@/views/personalCenter/changePwd'),
          meta: {
            title: '修改密码'
          }
        },
        {
          path: '/personalCenter/myInfo',
          name: 'myInfo',
          component: () => import( /* webpackChunkName: "myInfo" */ '@/views/personalCenter/myInfo'),
          meta: {
            title: '个人信息'
          }
        },
        {
          path: '/personalCenter/message/list',
          name: 'messageList',
          component: () => import( /* webpackChunkName: "myInfo" */ '@/views/personalCenter/message/list'),
          meta: {
            title: '消息列表'
          }
        },
        {
          path: '/personalCenter/message/detail/:id',
          name: 'messageDetail',
          component: () => import( /* webpackChunkName: "myInfo" */ '@/views/personalCenter/message/detail'),
          meta: {
            title: '消息详情'
          }
        },
        {
          path: '/personalCenter/group/list',
          name: 'group',
          component: () => import( /* webpackChunkName: "group" */ '@/views/personalCenter/group/index'),
          meta: {
            title: '我创建的团队'
          }
        },
        {
          path: '/personalCenter/group/myJoinTeam',
          name: 'myJoinTeam',
          component: () => import( /* webpackChunkName: "group" */ '@/views/personalCenter/group/myJoinTeam'),
          meta: {
            title: '我加入的团体'
          }
        },
        {
          path: '/personalCenter/group/teamInvite',
          name: 'teamInvite',
          component: () => import( /* webpackChunkName: "group" */ '@/views/personalCenter/group/teamInvite'),
          meta: {
            title: '团体邀请'
          }
        },
        {
          path: '/personalCenter/group/teamList',
          name: 'teamList',
          component: () => import( /* webpackChunkName: "group" */ '@/views/personalCenter/group/teamList'),
          meta: {
            title: '现有团体列表'
          }
        },
        {
          path: '/personalCenter/group/alreadyExist/:id',
          name: 'alreadyExist',
          component: () => import( /* webpackChunkName: "group" */ '@/views/personalCenter/group/alreadyExist'),
          meta: {
            title: '现有团体详情'
          }
        },
        {
          path: '/personalCenter/group/create',
          name: 'create',
          component: () => import( /* webpackChunkName: "group" */ '@/views/personalCenter/group/create'),
          meta: {
            title: '新建团体'
          }
        },
        {
          path: '/personalCenter/group/edit/:id',
          name: 'edit',
          component: () => import( /* webpackChunkName: "group" */ '@/views/personalCenter/group/create'),
          meta: {
            title: '团体修改'
          }
        },
        {
          path: '/personalCenter/mySuggest',
          name: 'mySuggest',
          component: () => import('@/views/personalCenter/mySuggest'),
          meta: {
            title: '我的建议',
          }
        },
        {
          path: '/personalCenter/personalRanking',
          name: 'personalRanking',
          component: () => import('@/views/personalCenter/personalRanking'),
          meta: {
            title: '个人排名',
          }
        },
        {
          path: '/personalCenter/publicWelfare',
          name: 'publicWelfare',
          component: () => import('@/views/personalCenter/publicWelfare'),
          meta: {
            title: '公益历程',
          }
        },
        {
          path: '/personalCenter/sharingInsights',
          name: 'sharingInsights',
          component: () => import('@/views/personalCenter/sharing/list'),
          meta: {
            title: '分享感悟',
          },
        },
        {
          path: '/personalCenter/sharingInsights/detail/:id',
          name: 'sharingInsightsdetail',
          component: () => import('@/views/personalCenter/sharing/detail'),
          meta: {
            title: '分享感悟详情',
          },
        },
        {
          path: '/personalCenter/sharingInsights/edit',
          name: 'sharingInsightEdit',
          component: () => import('@/views/personalCenter/sharing/edit'),
          meta: {
            title: '编辑感悟',
          },

        },
        {
          path: '/personalCenter/group/getVolunteerList/:id',
          name: 'getVolunteerList',
          component: () => import('@/views/personalCenter/group/getVolunteerList'),
          meta: {
            title: '邀请队员'
          }
        },
        {
          path: '/personalCenter/group/detail/:id',
          name: 'groupDetail',
          component: () => import( /* webpackChunkName: "group" */ '@/views/personalCenter/group/detail'),
        },
      ]
    },
    {
      path: '/information/detail/:id',
      name: 'informationDetail',
      component: () => import('@/views/information/detail'),
      meta: {
        title: '基金会资讯详情'
      }
    },
    {
      path: '/information/list/',
      name: 'information',
      component: () => import('@/views/information/list'),
      meta: {
        title: '基金会资讯'
      },
    },

  ],

})



// WEBPACK FOOTER //
// ./src/router/index.js